/**
 * Adds a tooltip to an existing element
 * <span help-tooltip="1001" />
 */
angular.module('qkr').directive('helpTooltip', ['helpService', function(helpService) {
        return {
            restrict: 'AE',
            replace: false,
            template: 'tooltip="{{helpMsg}}" id="{{helpId}}"',
            link(scope, elem, attrs) {
                if (typeof (attrs.helpTooltip) !== 'undefined') {
                    scope.helpId = attrs.helpTooltip;
                    if (helpService.helpLoaded) {
                        scope.helpMsg = helpService.tooltip(attrs.helpTooltip);
                    } else {
                        scope.$on('HelpLoaded', (as) => {
                            scope.helpMsg = helpService.tooltip(scope.helpId);
                        });
                    }
                }
            }
        };
}]);




// WEBPACK FOOTER //
// ./src/directives/help_tooltip.js